import { useMutation } from '@tanstack/react-query';
import apiInputService from 'services/apiInputService';

const downloadReport = async (reportId: string) => {
  const { data } = await apiInputService.get(`/report/download/${reportId}`);
  
  return data;
};

export const useDownloadReport = (options?: any) => {
  return useMutation(downloadReport, {
    ...options,
  });
};